module.exports = __webpack_public_path__ + "static/img/15_叫車服務.62506f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/15_叫車服務.png
// module id = NaWK
// module chunks = 1